export default __webpack_public_path__ + "static/cats-85615e8dd5cc6b95a1554805b5882064.png";